module.exports = __webpack_public_path__ + "static/second-f892a3e8580d7333c73c104f031b13ed.png";